<template>
  <div>
    <!-- <custom-header title="权限管理" >
    </custom-header> -->
    <public-header :title="name" show-back></public-header>
    <a-spin :spinning="loading">
      <div class="full-width bg-white border-radius-12" >
        <Layout :showMenu="true" :menuList="menuList" :defaultKeys="[0]" :activeKey.sync="key" :mainImage="false"  >
          <template slot="content" >
            <div v-show="key === 0" style="height:100%">
              <div class="font-14 font-bold m-b-20" style="color: #363B45" >{{ menuList[key].name }}</div>
              <a-row :gutter="[20,20]" class="font-12" style="color: #363B45" v-if="pageData && pageData.objectId" >
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  战区：{{ pageData.level === '4' ? pageData.agent.department.parentNode.name : pageData.department.parentNode.name }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  大区：{{ pageData.level === '4' ? pageData.agent.department.name : pageData.department.name }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  所属地区：{{ pageData.level === '4' ? $tkRegions.getFullName(pageData.agent.region) : $tkRegions.getFullName(pageData.region) }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="pageData.level === '4'"  >
                  所属代理商：{{ pageData.agent.nickName }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  姓名：{{ pageData.nickName }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  手机号：{{ pageData.phone }}
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8"  >
                  门店数：<storeNum :record="pageData" ></storeNum>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="8" :xl="8" v-if="pageData.QRcode" >
                  <tk-flex class="full-wdith">
                    <div style="text-align: right;flex-shrink: 0;">门店入驻二维码：</div>
                    <ak-type-input v-model="pageData.QRcode" :field="QRcodeOptions"  hideLabel />
                  </tk-flex>
                </a-col>
              </a-row>
            </div>
            <div v-show="key === 1" style="height:100%">
              <div class="font-14 font-bold m-b-20" style="color: #363B45" >{{ menuList[key].name }}</div>
              <ak-model-table model="subordinateStores" :perPage="20" ref="subordinateStores" :filters="storeFilters" tableSize="small"/>
            </div>
          </template>
        </Layout>
      </div>
    </a-spin>
  </div>
</template>
<script>
import Layout from '../components/layout.vue'
import publicHeader from '../../components/publicHeader.vue'
import storeNum from '../../core/component/userManagement/storeNum.vue'
export default {
  components: {
    publicHeader,
    Layout,
    storeNum
  },
  data () {
    return {
      loading: true, // 加载动画遮罩
      pageData: {},
      menuList: [
        {
          name: '基本信息'
        }
      ],
      storeFilters: {
        isDelete: false
      },
      key: 0,
      name: '',
      QRcodeOptions: {
        name: 'QRcode',
        note: '门店入驻二维码',
        type: 'Image',
        disabled: true
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化菜单按钮
    async init () {
      try {
        const { data } = await this.$tkParse.get(`/classes/_User/${this.$route.query.id}`, {
          params: { include: 'department,department.parentNode,role,agent,agent.department,agent.department.parentNode' }
        })
        if (data.level === '3' || data.level === '4') {
          this.menuList.push({
            name: '门店列表'
          })
          if (data.level === '3') {
            this.name = data.fullName
            this.storeFilters.agent = data.objectId
            this.storeFilters.agency = data.department.objectId
          } else {
            this.name = data.nickName
            this.storeFilters.salesman = data.objectId
            this.storeFilters.salesmancy = data.department.objectId
          }
        }
        console.log(data)
        this.pageData = data
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep{
  .array-img-input-wrap{
    .ignore-item {
      display: none;
    }
  }
}
</style>
